export type TrackingStartEvent = {
    event: 'gtm.js';
    'gtm.start': number;
};

export const trackingStarted = (): TrackingStartEvent => ({
    event: 'gtm.js',
    'gtm.start': new Date().getTime(),
});
